export const perspectiveLibraryCopy = {
  en: {
    profileTitle: 'Library preview',
    profileBody: 'Explore the shelves and open a sample book.',
    back: 'Back',
    title: 'A closer look',
    fixture: 'A little library · sample books',
    sampleFolioNote: 'Sample book, goal and challenge. Changes stay in this preview.',
    sampleGoalHint: "Update the sample book to change today's pages.",
    sampleChallengeNote:
      'This is a sample followed challenge. Reviews and rewards are not changed here.',
    chooseBook: 'Choose a book',
    chooseShelf: 'Choose a shelf',
    shelfTop: 'Top shelf',
    shelfMiddle: 'Middle shelf',
    shelfBottom: 'Bottom shelf',
    previousBooks: 'Previous books',
    nextBooks: 'Next books',
    preview: 'Take a closer look',
    openCover: 'Open the cover',
    closeCover: 'Close the cover',
    returnBook: 'Return to the shelf',
    shelfHint: 'Swipe books and decorations together. Tap a book for a closer look.',
    previewHint: 'Drag to turn the book in your hands.',
    reducedHint: 'Choose a shelf, then use the buttons to browse it.',
    reducedPreviewHint: 'Use the buttons to open or close the cover, or return the book.',
    sceneLabel: 'Three sample bookshelves. The middle books, plant, lamp and owl move together.',
    sceneAdjust: 'Adjust to browse the selected shelf.',
    previewAdjust: 'Adjust to turn the book.',
    selected: '{{title}}, by {{author}}',
  },
  sk: {
    profileTitle: 'Náhľad knižnice',
    profileBody: 'Prezri si police a otvor ukážkovú knihu.',
    back: 'Späť',
    title: 'Pozri sa zblízka',
    fixture: 'Malá knižnica · ukážkové knihy',
    sampleFolioNote: 'Ukážková kniha, cieľ a výzva. Zmeny zostanú iba v tomto náhľade.',
    sampleGoalHint: 'Aktualizuj ukážkovú knihu a zmeň tak počet dnešných strán.',
    sampleChallengeNote: 'Toto je ukážková sledovaná výzva. Recenzie ani odmeny sa tu nemenia.',
    chooseBook: 'Vyber si knihu',
    chooseShelf: 'Vyber si policu',
    shelfTop: 'Horná polica',
    shelfMiddle: 'Stredná polica',
    shelfBottom: 'Dolná polica',
    previousBooks: 'Predošlé knihy',
    nextBooks: 'Ďalšie knihy',
    preview: 'Pozrieť sa zblízka',
    openCover: 'Otvoriť obálku',
    closeCover: 'Zavrieť obálku',
    returnBook: 'Vrátiť do police',
    shelfHint: 'Potiahni knihy aj dekorácie do strany. Ťuknutím si prezri knihu zblízka.',
    previewHint: 'Potiahnutím otáčaj knihu v rukách.',
    reducedHint: 'Vyber si policu a tlačidlami si prezri jej obsah.',
    reducedPreviewHint: 'Tlačidlami otvor či zavri obálku alebo vráť knihu na policu.',
    sceneLabel:
      'Tri police s ukážkovými knihami. Na strednej sa knihy, rastlina, lampa a sova posúvajú spolu.',
    sceneAdjust: 'Úpravou prechádzaj knihy na vybranej polici.',
    previewAdjust: 'Úpravou otáčaj knihu.',
    selected: '{{title}}, autor: {{author}}',
  },
  cs: {
    profileTitle: 'Náhled knihovny',
    profileBody: 'Prohlédni si police a otevři ukázkovou knihu.',
    back: 'Zpět',
    title: 'Podívej se zblízka',
    fixture: 'Malá knihovna · ukázkové knihy',
    sampleFolioNote: 'Ukázková kniha, cíl a výzva. Změny zůstanou pouze v tomto náhledu.',
    sampleGoalHint: 'Aktualizuj ukázkovou knihu a změň tak počet dnešních stránek.',
    sampleChallengeNote: 'Toto je ukázková sledovaná výzva. Recenze ani odměny se zde nemění.',
    chooseBook: 'Vyber si knihu',
    chooseShelf: 'Vyber si polici',
    shelfTop: 'Horní police',
    shelfMiddle: 'Prostřední police',
    shelfBottom: 'Dolní police',
    previousBooks: 'Předchozí knihy',
    nextBooks: 'Další knihy',
    preview: 'Podívat se zblízka',
    openCover: 'Otevřít obálku',
    closeCover: 'Zavřít obálku',
    returnBook: 'Vrátit do police',
    shelfHint: 'Potáhni knihy i dekorace do strany. Klepnutím si prohlédni knihu zblízka.',
    previewHint: 'Tažením otáčej knihu v rukou.',
    reducedHint: 'Vyber si polici a tlačítky si prohlédni její obsah.',
    reducedPreviewHint: 'Tlačítky otevři či zavři obálku nebo vrať knihu na polici.',
    sceneLabel:
      'Tři police s ukázkovými knihami. Na prostřední se knihy, rostlina, lampa a sova posouvají společně.',
    sceneAdjust: 'Úpravou procházej knihy na vybrané polici.',
    previewAdjust: 'Úpravou otáčej knihu.',
    selected: '{{title}}, autor: {{author}}',
  },
} as const;
